<template>
  <v-app ref="app">
      <v-dialog
        v-model="dialog"
        scrollable
        max-width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :color="buttonColor"
            dark
            v-bind="attrs"
            v-on="on"
            ref="activator"
          >
            {{ $t('translate') }}
          </v-btn>
        </template>
        <v-card>
          <v-card-title>{{ $t('order_now') }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text >
            <OrderForm
            v-if="step==1"
            :url="baseUrl"
            :lang="lang"
            :postId="postId"
            @evaluation="evaluation"
            @success="successHandler"
            @error="errorHandler"
            ></OrderForm>
            <OrderSummary
            v-if="step==2"
            :url="baseUrl"
            :response="response"
            @success="successHandler"
            @error="errorHandler"
            ></OrderSummary>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div class="action-buttons">
              <v-btn
                color="blue darken-1"
                text
                @click="closeAction"
              >
                {{ $t('close') }}
              </v-btn>
              <v-btn v-if="step === 2"
                color="blue darken-1"
                text
                @click="backAction"
              >
                {{ $t('back') }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
      >
        {{ message }}

        <template v-slot:action="{ attrs }">
          <v-btn
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            {{ $t('close') }}
          </v-btn>
        </template>
      </v-snackbar>
  </v-app>
</template>
<script>
import i18n from '@/i18n';
import OrderForm from '@/components/OrderForm.vue';
import OrderSummary from '@/components/OrderSummary.vue';
import languages from '@cospired/i18n-iso-languages';
languages.registerLocale(require("@cospired/i18n-iso-languages/langs/en.json"));
languages.registerLocale(require("@cospired/i18n-iso-languages/langs/pl.json"));
export default {
  name: 'App',
  components: {
    OrderForm,
    OrderSummary
  },
  data: () => ({
    dialogm1: '',
    dialog: false,
    step: 1,
    response: {},
    snackbar: false,
    buttonColor: 'primary',
    snackbarColor: 'error',
    message: null,
    timeout: 2000,
    postId : null,
    lang: "Polish",
    baseUrl: "http://127.0.0.1:8000/wp-admin/admin-ajax.php",
    status:'',
    disabled: false
  }),
  computed: {
  },
  methods: {
    evaluation( item ){
      this.step = 2;
      this.$set( this, 'response', item)
    },
    successHandler( message ){
      this.step = 1;
      if(message) {
        this.color = 'success';
        this.message = this.$t( message );
        this.dialog = false;
        this.snackbar = true;
      }
    },
    errorHandler( message ){
      this.step = 1;
      if(message) {
        this.color = 'error';
        this.message = this.$t( message );
        this.dialog = false;
        this.snackbar = true;
      }
    },
    closeAction() {
      this.dialog = false;
    },
    backAction() {
      this.step = 1;
    }
  },
  mounted() {
    i18n.locale="pl";
    if( this.$refs.app.$el.closest(".turbotranslations-wrapper") ){
      let {postId, languageName, baseUrl, languageI18n} = this.$refs.app.$el.closest(".turbotranslations-wrapper").dataset;
      this.code = languages.getAlpha2Code( languageName, "en");
      this.languageCode = languages.getAlpha2Code( languageI18n, "en");
      i18n.locale = this.languageCode;
      this.postId = postId;
      this.baseUrl = baseUrl;
      this.lang = languageName;
    }
  }
};
</script>
<style>
.v-application--wrap{
  min-height: auto !important;
}

.turbotranslations-wrapper input[type="text"]{
  border-radius:none;
  border:none;
  background-color:transparent;
  outline:none !important;
  box-shadow: none !important
}
.action-buttons {
  display:flex;
  align-items: center;
  justify-content:space-between;
  width:100%;
}
</style>
